import api, { Header } from '../../base';
import {
  AllegroCreateResponsiblePersonRequest,
  AllegroResponsiblePerson,
  AllegroResponsiblePersons,
  AllegroUpdateResponsiblePersonRequest,
} from './responsiblePersonTypes';
import { mockAllegroResponsiblePerson, mockGetAllegroResponsiblePersons } from './responsiblePersonMocks';

const RESPONSIBLE_PERSONS_PATH = 'allegro-api/sale/responsible-persons';

export async function getAllegroResponsiblePersons(
  marketplaceCode: string,
  offset: number = 0,
  limit: number = 1000,
  signal?: AbortSignal,
): Promise<AllegroResponsiblePersons> {
  const response = await api.get<AllegroResponsiblePersons>(
    RESPONSIBLE_PERSONS_PATH,
    {
      headers: {
        [Header.X_ESHOP_CODE]: marketplaceCode,
        [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
      },
      params: { offset, limit },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onGet('allegro-api/sale/responsible-persons')
  .reply(200, mockGetAllegroResponsiblePersons);

export async function createAllegroResponsiblePerson(
  marketplaceCode: string,
  payload: AllegroCreateResponsiblePersonRequest,
  signal?: AbortSignal,
): Promise<AllegroResponsiblePerson> {
  const response = await api.post<AllegroResponsiblePerson>(
    RESPONSIBLE_PERSONS_PATH,
    payload,
    {
      headers: {
        [Header.X_ESHOP_CODE]: marketplaceCode,
        [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
        [Header.CONTENT_TYPE]: 'application/vnd.allegro.public.v1+json',
      },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onPost('allegro-api/sale/responsible-persons')
  .reply(200, mockAllegroResponsiblePerson);

export async function updateAllegroResponsiblePerson(
  marketplaceCode: string,
  id: string,
  payload: AllegroUpdateResponsiblePersonRequest,
  signal?: AbortSignal,
): Promise<AllegroResponsiblePerson> {
  const response = await api.put<AllegroResponsiblePerson>(
    `${RESPONSIBLE_PERSONS_PATH}/${id}`,
    payload,
    {
      headers: {
        [Header.X_ESHOP_CODE]: marketplaceCode,
        [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
        [Header.CONTENT_TYPE]: 'application/vnd.allegro.public.v1+json',
      },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onPut(/allegro-api\/sale\/responsible-persons\/.+/)
  .reply(200, mockAllegroResponsiblePerson);
